import React from 'react';
import "../less";
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock';
import TextBlock from '../../../../../auxiliary-components/shared/TextBlock';
import TextField from '@abank/abank-text-field';
import { getSafeLinkProps } from '../../../../../helpers/utils/urlSecurity';

export default function template() {
    const model = this.getModel();
    let { documentCode } = model.fields;

    return (
        <div className="module-service-document">
          <div className="module-service-document__top">
            <TitleBlock title={'SERVICE_CHECK_DOCUMENT_TITLE'} tag="h1"/>
            <TextBlock text={'SERVICE_CHECK_DOCUMENT_DESC'}/>
            <TextBlock text={'SERVICE_CHECK_DOCUMENT_DESC_02'}/>
          </div>
          <div className="document-check">
            <div className="container">
              <div className="document-check__body">
                {!this.state.isSuccess ? (
                  <form className="document-check__form form-document-check" action="" method="get" onSubmit={this.sendForm}>
                    <TextField
                      subtitle={this.l10n("SERVICE_CHECK_DOCUMENT_FORM_TITLE")}
                      isError={documentCode.errors.length || this.state.isGlobalError}
                      error={this.state.isGlobalError && !documentCode.errors.length ? this.l10n(this.state.globalErrorText) : this.l10n(documentCode.errors)}
                      placeholder={this.l10n('SERVICE_CHECK_DOCUMENT_FORM_PLACEHOLDER')}
                      type="text"
                      name="documentCode"
                      value={documentCode.value}
                      onChange={this.handleChange}
                      maxLength={19}
                      autoComplete="off"
                    />
                    <button className={`form-document-check__btn ${!model.isValid || this.state.isDisabled ? 'form-document-check__btn_disabled' : ''}`} disabled={!model.isValid || this.state.isDisabled}>{this.l10n('SERVICE_CHECK_DOCUMENT_BTN')}</button>
                  </form>
                ) : (
                  <div className="document-check__result result-document-check">
                    <div className="result-document-check__title">{this.l10n('SERVICE_CHECK_DOCUMENT_CHECK_TITLE')}</div>
                    <div className="result-document-check__text">
                      {this.l10n('SERVICE_CHECK_DOCUMENT_CHECK_CAN')} <a {...getSafeLinkProps(this.state.documentUrl, { target: '_blank' })} className="document-result-links-item">{this.l10n('SERVICE_CHECK_DOCUMENT_CHECK_DOWNLOAD')}</a> {this.l10n('SERVICE_CHECK_DOCUMENT_CHECK_OR')} <span onClick={this.backToCheck} className="document-result-links-item">{this.l10n('SERVICE_CHECK_DOCUMENT_CHECK_VIEW')}</span> {this.l10n('SERVICE_CHECK_DOCUMENT_CHECK_DOCUMENTS')}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
    );
}
